import { call, put } from 'redux-saga/effects';

import { newTrial } from '../../actions/account/licence';
import { fetchOrganizations, fetchUserInfos, newOrganization } from '../../actions/account/user';
import { getAuthInstance } from '../../firebase';
import { organizations as avaOrganizations } from '../../services/api/ava';
import { organizations as saasOrganizations } from '../../services/api/saas';

export function* postOrganization({ payload }: any) {
  try {
    const res = yield call(saasOrganizations.createOrganization, { ...payload });
    const data = yield call([res, res.json]);

    yield put(fetchUserInfos.request());
    yield put(newTrial.request(data.organization));
    yield put(newOrganization.success(data));
  } catch (err: any) {
    yield put(newOrganization.failure(err.message));
  }
}

export function* searchOrganizations({ orgName, orgType }: any) {
  try {
    const firebaseUser = getAuthInstance().currentUser;
    if (!firebaseUser) {
      return;
    }

    const reqData = {
      firebaseAuthUID: firebaseUser.uid,
      orgName,
      orgType,
    } as const;
    const res = yield call(avaOrganizations.findOrganizations, reqData);
    const data = yield call([res, res.json]);
    yield put(fetchOrganizations.success(data));
  } catch (err: any) {
    yield put(fetchOrganizations.failure(err.message));
  }
}
